module.exports = __webpack_public_path__ + "static/media/bg-valley-tablet.b9223dc4.jpg";